import * as React from 'react';
const { useCallback, useMemo } = React;
import * as moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';

import DateRangePicker, { DateRangePickerProps } from '../date-range-picker';
import TextField, { TextFieldProps } from '../text-field';
import IconButton from '../icon-button';
import Icon from '../icon';
import { prettyDate } from '../../utils/date';
import { BASE_DATE_FORMAT } from '../../constants';
import { TextFieldLayout } from './styled';


const useIconButtonStyles = makeStyles(() => ({
	iconButton: {
		padding: '6px',
		'&.MuiIconButton-edgeEnd': {
			marginRight: 0
		}
	}
}));

const rootProps = {
	fullWidth: true,
};

const popperProps = {
	animationFrom: 'end',
} as any;

export type DateRangeFieldProps = {
	dateStart: string;
	dateEnd: string;
	fullWidth?: boolean;
	onChange: DateRangePickerProps['onChange'];
} & Omit<TextFieldProps,
	'value'
	| 'fullWidth'
	| 'onChange'>;

const DateRangeField: React.SFC<DateRangeFieldProps> = (props) => {
	const {
		dateStart,
		dateEnd,
		fullWidth,
		onChange,
		...rest
	} = props;
	const classes = useIconButtonStyles({});
	const defaultPeriod = useMemo(() => ({
		dateStart: moment().format(BASE_DATE_FORMAT),
		dateEnd: moment().format(BASE_DATE_FORMAT),
	}), []);

	const handleClear = useCallback((e: React.SyntheticEvent<{}>) => {
		e.stopPropagation();
		onChange(null, null);
	}, [onChange]);

	const formattedValue = dateStart && dateEnd
		? `${prettyDate(dateStart)} - ${prettyDate(dateEnd)}`
		: '';

	const renderTrigger = useMemo(() => ({ handleOpen }: { handleOpen: () => void }) => {
		return (
			<TextFieldLayout onClick={handleOpen}>
				<TextField
					{...rest}
					value={formattedValue}
					fullWidth
					InputProps={{
						endAdornment: 
							<IconButton
								edge='end'
								aria-label='Очистить поле'
								title='Очистить поле'
								className={classes.iconButton}
								onClick={handleClear}>
								<Icon
									type='clear'
									color='muted'
									width={16}
									height={16}
								/>
							</IconButton>
					}}
				/>
			</TextFieldLayout>
		)
	}, [formattedValue, handleClear]);

	return (	
		<DateRangePicker
			appearance='popper'
			dateStart={dateStart || defaultPeriod.dateStart}
			dateEnd={dateEnd || defaultPeriod.dateEnd}
			RootProps={rootProps}
			PopperProps={popperProps}
			renderTrigger={renderTrigger}
			syncDates
			onChange={onChange}
		/>
	);
}

DateRangeField.displayName = 'DateRangeField';
DateRangeField.defaultProps = {};

export default DateRangeField;
